import React from "react";

function AboutUs() {
  return (
    <div className="bg-white h-screen dark:bg-gray-900 pt-10 pb-28 lg:mb-16 font-light  text-gray-500 dark:text-gray-400 sm:text-xl ">
      <div className="p-[10%] ">
        <div className="text-4xl  font-extrabold text-gray-900 dark:text-white">About</div>
        <hr />
        <br />
        <h2 className="text-2xl text-gray-500 dark:text-gray-300 ">
          We’re your single contact for all your event needs!
        </h2>
        <p className="text-sm ">
          Planners and producers prefer to work with a single contact for all
          their meeting needs. You will have a person dedicated to you from
          start to finish. Our professionals will work with you to create
          seamless coordination of every detail for a successful meeting.
        </p>
        <br />
        <h2 className="text-2xl text-gray-500 dark:text-gray-300">We’re the technology experts</h2>
        <p className="text-sm">
          When the event goes live, it’s more than just a meeting requiring
          equipment and an AV guy. It’s a total experience; it’s a show. It
          takes people who will pull it all together. There is not a more
          dedicated group than Athans Audio Visual.
        </p>
        <br />
        <h2 className="text-2xl text-gray-500 dark:text-gray-300">Peace of Mind</h2>
        <p className="text-sm">
          Once you have chosen Athans Audio Visual for your event, you can be
          assured that the success of your event is in good hands. Our
          enthusiasm will be quite visible in responding to your needs. We would
          be grateful for the opportunity to be a part of your organization.
        </p>
      </div>
    </div>
  );
}

export default AboutUs;
